import { SVGProps } from 'react';

const IconChevronRight = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg width={8} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.705 0 .295 1.41 4.875 6l-4.58 4.59L1.705 12l6-6-6-6Z" fill="#696F88" />
  </svg>
);

export default IconChevronRight;
